import { forwardRef, useEffect } from 'react';

import styles from './ContentsLinks.module.css';

interface ContentsLinksProps {
  activeSectionId: string | undefined;
  hasCommonQuestions?: boolean;
  strings: Record<string, string>;
}

const ContentsLinks = forwardRef<HTMLElement, ContentsLinksProps>(
  ({ activeSectionId, hasCommonQuestions, strings }: ContentsLinksProps, ref) => {
    const getClassName = (id: string) => (id === activeSectionId ? styles.active : '');

    useEffect(() => {
      if (ref && activeSectionId) {
        const cta = [...ref.current.children].find(
          child => child.id === `#${activeSectionId}-link`,
        );
        if (cta) {
          ref.current.scrollTo({
            left: cta.offsetLeft,
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    }, [activeSectionId, ref]);

    return (
      <section className={styles.wrapper} ref={ref}>
        <a id="#overall-link" href="#overall" className={getClassName('overall')}>
          {strings.overall}
        </a>
        <a id="#inside-link" href="#inside" className={getClassName('inside')}>
          {strings.inside}
        </a>
        <a id="#driving-link" href="#driving" className={getClassName('driving')}>
          {strings.driving}
        </a>
        <a id="#running-link" href="#running-cost" className={getClassName('running-cost')}>
          {strings.runningCost}
        </a>
        <a id="#versions-link" href="#versions" className={getClassName('versions')}>
          {strings.versions}
        </a>
        {hasCommonQuestions && (
          <a id="#questions-link" href="#questions" className={getClassName('questions')}>
            {strings.commonQuestions}
          </a>
        )}
      </section>
    );
  },
);

ContentsLinks.displayName = 'ContentsLinks';

export default ContentsLinks;
